import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "16",
  "aria-hidden": "true",
  viewBox: "0 0 18 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "none" }, [
      _createElementVNode("path", {
        d: "M.243 13.293 7.309.986C7.661.375 8.304 0 9 0s1.34.375 1.691.986l7.066 12.307c.159.275.243.59.243.907 0 .993-.795 1.8-1.772 1.8H1.772C.795 16 0 15.193 0 14.2c0-.318.084-.632.243-.907",
        class: "icon-advisories-outline"
      }),
      _createElementVNode("path", {
        d: "M1.213 13.871a.7.7 0 0 0-.088.333.65.65 0 0 0 .647.657h14.456a.65.65 0 0 0 .647-.657.7.7 0 0 0-.088-.333L9.721 1.564c-.151-.26-.426-.421-.721-.421s-.57.16-.72.421z",
        class: "icon-advisories-fill"
      }),
      _createElementVNode("path", {
        d: "M10.125 12c0-.631-.504-1.143-1.125-1.143S7.875 11.37 7.875 12 8.379 13.143 9 13.143s1.125-.512 1.125-1.143m-.281-6.571c0-.475-.376-.858-.844-.858s-.844.383-.844.858v3.428c0 .475.376.857.844.857s.844-.382.844-.857z",
        class: "icon-advisories-exclamation"
      })
    ], -1)
  ])))
}
export default { render: render }